import type { Playbook } from "./types";

/** Crisis and hostage negotiation: officers on a team and the students
 * training to join one. Prep follows what a negotiation team's intelligence
 * function collects before first contact. */
export const crisisNegotiationPlaybook: Playbook = {
  id: "crisis-negotiation",
  framework: "bcsm",
  labels: {
    name: "crisis.name",
    summary: "crisis.summary",
    counterpart: "crisis.counterpart",
    learner: "crisis.learner",
  },
  prep: [
    {
      id: "situation",
      label: "crisis.prep.situation",
      hint: "crisis.prep.situationHint",
      kind: "longtext",
      required: true,
      maxLength: 3000,
    },
    {
      id: "subject",
      label: "crisis.prep.subject",
      hint: "crisis.prep.subjectHint",
      kind: "longtext",
      required: true,
      maxLength: 3000,
    },
    {
      id: "people",
      label: "crisis.prep.people",
      hint: "crisis.prep.peopleHint",
      kind: "longtext",
      required: false,
      maxLength: 3000,
    },
    {
      id: "demands",
      label: "crisis.prep.demands",
      hint: "crisis.prep.demandsHint",
      kind: "longtext",
      required: false,
      maxLength: 2000,
    },
    {
      id: "hooksAndTriggers",
      label: "crisis.prep.hooksAndTriggers",
      hint: "crisis.prep.hooksAndTriggersHint",
      kind: "longtext",
      required: false,
      maxLength: 2000,
    },
    {
      id: "pastContact",
      label: "crisis.prep.pastContact",
      hint: "crisis.prep.pastContactHint",
      kind: "longtext",
      required: false,
      maxLength: 12000,
    },
  ],
  trainingOnly: false,
};
